import { EmpPosition } from '~/data/employee';
import { AllEnums, Enum } from '~/data/enums';
import { LegalEntity, getCountryByLegalEntity } from '~/data/legalEntity';

import {
  filterEnumsByCountry,
  jsIsEmpStatus,
  sortEnumLables,
} from '../CustomDataFields';

import {
  CustomField,
  CustomFieldType,
  CustomFieldValues,
  FieldAttributes,
  FieldAttributesHash,
  FieldLang,
} from './types';

function customFieldEditModeOld(
  customField: FieldAttributes,
  customFieldValues: CustomFieldValues,
  customFieldLang: FieldLang[],
  labelText: string,
): CustomField {
  const strName = customField.fCustomDataAttributeName;
  const strType = customField.fCustomDataAttributeDataType as CustomFieldType;
  const strValue = customFieldValues.hasOwnProperty(strName)
    ? customFieldValues[strName]
    : '';
  const fieldLang = customFieldLang.find(
    (e: FieldLang) => customField.fCustomDataAttributeName === e.code,
  );
  return {
    groupName: customField.fCustomDataAttributeDataSubtype || '',
    code: fieldLang?.code || '',
    description: fieldLang?.description || '',
    label: labelText,
    name: strName,
    inputType: {
      label: customField.fCustomDataAttributeLabel,
      value: CustomFieldType[strType],
    },
    value: strValue,
  };
}

export const editCustomFieldDataOld = async (
  empStatus: string,
  empPosition: EmpPosition,
  customFieldAttributesHash: FieldAttributesHash,
  customFieldLang: FieldLang[],
  customFields: CustomFieldValues,
  empPositionPending?: EmpPosition | number,
  allEnums?: AllEnums,
  legalEntities?: LegalEntity[],
): Promise<CustomField[]> => {
  const empPositionData =
    (jsIsEmpStatus(empStatus, 'NEW') || jsIsEmpStatus(empStatus, 'PENDING')) &&
    empPositionPending
      ? empPositionPending
      : empPosition;
  const legalEntityCountry = getCountryByLegalEntity(
    (empPositionData as EmpPosition).fEmpLegalEntity as number,
    legalEntities,
  );
  const labels = filterEnumsByCountry(
    (allEnums as AllEnums)[`CUSTOM_ENTITY_DECISION_REGISTRY`],
    '',
    legalEntityCountry,
  );
  let sortedLabels = labels.sort(sortEnumLables);
  return sortedLabels.map((label: Enum) => {
    const field: FieldAttributes = customFieldAttributesHash[label.code];
    return {
      ...customFieldEditModeOld(
        field,
        customFields,
        customFieldLang,
        label.name,
      ),
    };
  });
};
